import {Button, Col, Drawer, Form, Input, Row, Typography} from "antd";
import React, {useEffect, useState} from "react";
import {useBoxesAddBoxMutation} from "@mwServices/Boxes";
import {showResponse} from "@services/Api";
import useHasPermission from "@hooks/useHasPermission";
import {useWindowSize} from "@components/window-size-provider";

const { TextArea } = Input;

const BoxAddDrawerContent = ({form, onClose, issue_ids, series_ids}) => {
    const [initForm] = useState({
        name: '',
        description: '',
    });
    const [callAddBox, addBoxResponse] = useBoxesAddBoxMutation();
    const [nameError, setNameError] = useState<string>('');

    useEffect(() => {
        let isBoxNameError = false;
        let errorMessage = 'Failed to create the Virtual Box.';
        if (!addBoxResponse.isLoading && addBoxResponse.data) {
            if (addBoxResponse.data.success === 0) {
                if(addBoxResponse.data.error === 'box_name_exists' ){
                    isBoxNameError = true;
                    errorMessage = "Virtual Box name already exists, please choose another one.";
                    setNameError(errorMessage);
                }
                else if(addBoxResponse.data.error === 'no_pipe_marks' ){
                    isBoxNameError = true;
                    errorMessage = "Virtual Box name cannot contain pipe marks, please choose another name.";
                    setNameError(errorMessage);
                }
            }

            showResponse(addBoxResponse, 'Virtual Box created', errorMessage);

            if(!isBoxNameError){
                form.resetFields();
                setNameError("");
                onClose();
            }
        }
    }, [addBoxResponse]);

    const submitForm = async (values) => {
        let sanitisedData = {...values, issue_ids, series_ids};
        let createBox = true;

        if(values.name && values.name.indexOf('|') !== -1){
            createBox = false;
            setNameError("Virtual Box name cannot contain pipe marks, please choose another name.");
        }

        if(createBox) await callAddBox(sanitisedData);
    };

    return (
        <>
            <Row className="pad-bot-20">
                <Col span={24}>
                    <Typography>Virtual Boxes allow you to create subgroups of your main collection. Max 20 boxes per user.</Typography>
                </Col>
            </Row>

            <Form
                labelCol={{span: 8}}
                initialValues={initForm}
                wrapperCol={{span: 16}}
                form={form}
                name="control-hooks"
                onFinish={submitForm}
            >
                <Row>
                    <Col span={4} className="align-left-top">
                    </Col>
                    <Col span={20}>
                        <Form.Item label="Virtual Box Title" labelAlign={"left"} name="name" validateStatus={nameError !== '' ? "error" : ""} help={nameError}>
                            <Input placeholder="Title" />
                        </Form.Item>

                        <Form.Item label="Description" labelAlign={"left"} name="description">
                            <TextArea rows={4} placeholder="Optional" maxLength={1000} showCount />
                        </Form.Item>
                    </Col>
                </Row>
        </Form>
        </>
    );
};

const BoxesAddDrawer = ({visible, onClose, issue_ids, series_ids}) => {
    const [form] = Form.useForm();
    const windowDimensions = useWindowSize();
    const [drawerWidth, setDrawerWidth] = useState(450);
    const isAdmin = useHasPermission('admin');

    const onCloseExec = () => {
        form.resetFields();
        onClose();
    };

    useEffect(() => {
        const newWidth = (windowDimensions.width < 450) ? windowDimensions.width : 450;
        if(newWidth !== drawerWidth) setDrawerWidth(newWidth);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowDimensions]);

    return (
        <Drawer
            title="Create A Virtual Box (VB)"
            className={"issue-edit-drawer"}
            headerStyle={{paddingTop: isAdmin ? 50 : 16}}
            width={drawerWidth}
            placement="right"
            onClose={onCloseExec}
            open={visible}
            footer={
                <Row justify="center">
                    <Col >
                        <Button className="outlineButton thickButton width-250px" onClick={() => form.submit()}>Create Virtual Box</Button>
                    </Col>
                </Row>
            }
        >
            {visible && (
                <BoxAddDrawerContent onClose={onCloseExec} form={form} issue_ids={issue_ids} series_ids={series_ids} />
            )}
        </Drawer>
    );
};

export default BoxesAddDrawer;